import { defineStore } from 'pinia'
import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface Toast {
  id: number
  type: ToastType
  text: string
  timeout: number
}

let nextId = 1

export const useToastStore = defineStore('toast', () => {
  const items = ref<Toast[]>([])

  function push(type: ToastType, text: string, timeout = 4000) {
    const id = nextId++
    items.value.push({ id, type, text, timeout })
    return id
  }

  function close(id: number) {
    const i = items.value.findIndex((t) => t.id === id)
    if (i >= 0) items.value.splice(i, 1)
  }

  return {
    items,
    push,
    success: (t: string, ms?: number) => push('success', t, ms),
    error: (t: string, ms?: number) => push('error', t, ms ?? 6000),
    info: (t: string, ms?: number) => push('info', t, ms),
    warning: (t: string, ms?: number) => push('warning', t, ms),
    close,
  }
})
